// 配置埋点基础字段
export function setBaBaseConfig({ userInfo }) {
  window._ba2 = window._ba2 || []

  // 增加用户信息
  window._ba2.push(['set', 'uid', userInfo.id])
  window._ba2.push(['setExt', 'tenantId', userInfo.tenantId])
}

// 上报路由信息
export function upRoute(to, from) {
  try {
    window._ba2 = window._ba2 || []
    window._ba2.push(['afterRouter', function () {
      window._ba2.push(['setExt', 'resourceName', to.name || ''])
      window._ba2.push(['setExt', 'referrerResourceName', from.name || ''])
    }])
  } catch (error) {
    console.log('埋点上报路由信息报错 error:', error)
  }
}

/**
 * 快速上报
 * eventType： click, change, lv ..
 */

export function quick(eventType, eventId, data = {}) {
  if (!eventType || !eventId) {
    console.log('缺少上报事件类型和事件id')
    return
  }
  try {
    window._ba2 = window._ba2 || []
    window._ba2.push(['custom_event', function () {
      this.report({
        event_type: eventType,
        event_time: new Date().getTime(),
        event_id: encodeURIComponent(eventId),
        ext: {
          data,
        },
      })
    }])
  } catch (error) {
    console.log('埋点快速信息上报报错 error:', error)
  }
}